import React from "react";
const StatusPill = ({ text }) => {
  const statusLookup = {
    inactive: {
      text: "Inactive",
      color: "#495057",
      bgcolor: "#f1f1f5",
    },
    active: {
      text: "Active",
      color: "#12B76A",
      bgcolor: "#eafff5",
    },
  };
  const status = statusLookup[text];
  return (
    <div
      className="status-pill"
      style={{
        backgroundColor: `${status["bgcolor"]}`,
        color: `${status["color"]}`,
      }}
    >
      <label style={{ color: `${status["color"]}` }}>{status["text"]}</label>
    </div>
  );
};

export default StatusPill;
